import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G6_P4_S1_Name: {
    id: `guide06.page04.slide01.name`,
  },
  G6_P4_S2_Name: {
    id: `guide06.page04.slide02.name`,
  },
  G6_P4_S3_Name: {
    id: `guide06.page04.slide03.name`,
  },
  G6_P4_S4_Name: {
    id: `guide06.page04.slide04.name`,
  },

  //Phase
  G6_P4_S1_Title: {
    id: `guide06.page04.slide01.title`,
  },
  G6_P4_S1_Description: {
    id: `guide06.page04.slide01.description`,
  },
  //Loop
  G6_P4_S2_S1_Title: {
    id: `guide06.page04.slide02.subslide01.title1`,
  },
  G6_P4_S2_S1_Description: {
    id: `guide06.page04.slide02.subslide01.description`,
  },
  G6_P4_S2_S2_Title: {
    id: `guide06.page04.slide02.subslide02.title`,
  },
  G6_P4_S2_S2_Description1: {
    id: `guide06.page04.slide02.subslide02.description1`,
  },
  G6_P4_S2_S2_Item1: {
    id: `guide06.page04.slide02.subslide02.item1`,
  },
  G6_P4_S2_S2_Item2: {
    id: `guide06.page04.slide02.subslide02.item2`,
  },
  G6_P4_S2_S2_Item3: {
    id: `guide06.page04.slide02.subslide02.item3`,
  },
  G6_P4_S2_S2_Item4: {
    id: `guide06.page04.slide02.subslide02.item4`,
  },
  G6_P4_S2_S2_Item5: {
    id: `guide06.page04.slide02.subslide02.item5`,
  },
  G6_P4_S2_S2_Description2: {
    id: `guide06.page04.slide02.subslide02.description2`,
  },
  //Milldeware
  G6_P4_S3_Title: {
    id: `guide06.page04.slide03.title`,
  },

  //Realtime renering
  G6_P4_S4_Title: {
    id: `guide06.page04.slide04.title`,
  },
});
